import emitter from 'core/emitter/emitter'

export function viewErrorMessage(message: string) {
  emitter.emit('notify', {
    message,
    type: 'error',
  })
}

export function viewWarningMessage(message: string) {
  emitter.emit('notify', {
    message,
    type: 'warning',
  })
}

export function viewSuccessMessage(message: string) {
  emitter.emit('notify', {
    message,
    type: 'success',
  })
}
